/** Module-level holder for the current preferences so non-React code (formatters, key handlers) can read them without a hook. */

import { DEFAULT_PREFERENCES, type UserPreferences } from './preferencesSchema';

let snapshot: UserPreferences = DEFAULT_PREFERENCES;
const listeners = new Set<() => void>();

export function getPreferencesSnapshot(): UserPreferences {
  return snapshot;
}

export function subscribePreferences(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function setPreferencesSnapshot(next: UserPreferences): void {
  if (next === snapshot) return;
  snapshot = next;
  listeners.forEach((listener) => listener());
}
